export default __webpack_public_path__ + "static/media/logo_julian_dark.88040fff.svg";